module.exports = __webpack_public_path__ + "img/flow-num-2.6a18ae61.svg";